export default __webpack_public_path__ + "static/media/independent-grocery-shop-square.8dd20135.png";